import { Box, Button, Grid, Link, Typography } from "@mui/material"
import { AccessTime, BusinessRounded, Lens } from '@mui/icons-material'
import { useTranslation } from "react-i18next"
import calendarStyles from "../../../styles/EventsCalendarStyles"
import { useNavigate } from "react-router"
import classNames from 'clsx'
import { useTheme } from '@mui/material/styles'
import Visbility from '../../../../../shared/components/frontoffice/Visibility'

export const Content = ({ formatDate, appointmentData }: any) => {
  const { t } = useTranslation(['global'])
  const theme = useTheme()
  const classes = calendarStyles(theme, {
    color: appointmentData.brand != null ? appointmentData.brand.main_color : appointmentData.background_color
  })
  const navigate = useNavigate()
  const startValidation = formatDate(appointmentData.startDate, { month: 'long', day: 'numeric' })
  const endValidation = formatDate(appointmentData.endDate, { month: 'long', day: 'numeric' })

  return (
    <Box sx={classes.content}>
      <Grid container alignItems="flex-start" sx={classes.titleContainer}>
        <Grid item xs={2} sx={classes.textCenter}>
          <Lens className={classNames(classes.lens, classes.colorfulContent)} />
        </Grid>
        <Grid item xs={10}>
          <div>
            <div className={classNames(classes.title, classes.dateAndTitle)}>{appointmentData.title}</div>
            {startValidation === endValidation ? (
              <div className={classNames(classes.text, classes.dateAndTitle)}>
                {formatDate(appointmentData.startDate, {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </div>
            ) : (
              <div className={classNames(classes.text, classes.dateAndTitle)}>
                {`${formatDate(appointmentData.startDate, { weekday: 'long', month: 'long', day: 'numeric' })}
                                - ${formatDate(appointmentData.endDate, { weekday: 'long', month: 'long', day: 'numeric' })}`}
              </div>
            )}
            {appointmentData.speaker && (
              <div className={classNames(classes.text, classes.dateAndTitle, classes.spaker)}>
                <Typography
                  variant="body2"
                  style={{
                    color: appointmentData.brand != null ? appointmentData.brand.main_color : appointmentData.background_color
                  }}
                >
                  {t('speaker')}:
                </Typography>
                {appointmentData.speaker}
              </div>
            )}
            {appointmentData.description && (
              <div className={classNames(classes.text, classes.description)}>
                <Typography
                  variant="body2"
                  style={{
                    color: appointmentData.brand != null ? appointmentData.brand.main_color : appointmentData.background_color
                  }}
                >
                  {t('description')}
                </Typography>
                {appointmentData.description}
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      <Grid container alignItems="center" sx={classes.contentContainer}>
        <Grid sx={classes.textCenter} item xs={2}>
          <BusinessRounded />
        </Grid>
        <Grid item xs={4}>
          <Typography>{appointmentData.brand.name}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Visbility type={0} />
        </Grid>
      </Grid>
      <Grid container alignItems="center" sx={classes.contentContainer}>
        <Grid item xs={2} sx={classes.textCenter}>
          <AccessTime sx={classes.icon} />
        </Grid>
        <Grid item xs={10}>
          <Box sx={classes.text}>
            {`${formatDate(appointmentData.startDate, { hour: 'numeric', minute: 'numeric', hour12: true })}
                        - ${formatDate(appointmentData.endDate, { hour: 'numeric', minute: 'numeric', hour12: true })}`}
          </Box>
        </Grid>
      </Grid>

      <Grid container alignItems="center" justifyContent="center" key={`${appointmentData.text_button}_${appointmentData.id}`}>
        <Grid item xs={4}>
          <Button
            variant="contained"
            className={classNames(classes.callToActionBtn)}
            onClick={() => {
              navigate(`/eventos/${appointmentData.id}`)
            }}
          >
            {t('see-details')}
          </Button>
        </Grid>
        {appointmentData.link && (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Link
              className={classNames(classes.saveBtnForm)}
              component="a"
              variant="body2"
              rel="noopener noreferrer"
              target="_blank"
              href={appointmentData.link}
            >
              {appointmentData.text_button != null ? appointmentData.text_button : t('admin.events.join-here')}
            </Link>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}